import { catchError, map, Observable, of } from 'rxjs'
import { Injectable } from '@angular/core'

import { ILeaseList } from '@modules/private/lease/data/interfaces/ilease.interface'
import { ClientLeaseDocuments } from '@data/interfaces/documents.interface'
import { IResponseArray } from '@data/interfaces/iresponseArray.interface'
import { ApiClass } from '@data/class/api-class'
import { environment } from '@env/environment'

@Injectable({
  providedIn: 'root',
})
export class ApiLeaseService extends ApiClass {
  id!: string

  constructor() {
    super()
    this.path = 'leases'
  }

  getAll(page = 1, limit = 10, filters = {}) {
    const response: ILeaseList = {
      error: true,
      msg: '',
      data: [],
      total: 0,
      status: 200,
      page: 1,
      itemsByPage: 10,
      totalItems: 0,
    }

    filters = {
      client: { value: this.id, matchMode: 'equals' },
    }

    const populate = [
      { path: 'client' },
      { path: 'committee' },
      { path: 'documents' },
      {
        path: 'quotation',
        populate: [
          {
            path: 'amortizationPeriods',
            model: 'AmortizationPeriod',
          },
          {
            path: 'assets',
            model: 'Asset',
          },
        ],
      },
    ]

    return this.http.post<IResponseArray>(environment.apiUrl + this.path, { page, limit, filters, populate }).pipe(
      map((r) => r as ILeaseList),
      catchError(() => of(response)),
    )
  }

  /**
   * F-009 · Todos los arrendamientos del cliente (cualquier estado) con `documents` poblado: las pestañas de
   * solo lectura del expediente en el detalle del cliente. No reutiliza `getAll`: `findAll` descarta el populate.
   * La API ignora `populateDocuments` para Client, Broker y MasterBroker; al panel solo entra staff.
   * A diferencia del resto de la clase, el error se propaga: la pestaña distingue «falló» de «no tiene».
   */
  getByClientWithDocuments(clientId: string): Observable<ClientLeaseDocuments[]> {
    return this.http.get<{ error: boolean; msg?: string; data: ClientLeaseDocuments[] }>(`${environment.apiUrl}${this.path}/by-client/${clientId}?onlyActive=false&populateDocuments=true`).pipe(
      map((r) => {
        if (r?.error) throw new Error(r.msg || 'No se pudieron cargar los arrendamientos del cliente')
        return r?.data ?? []
      }),
    )
  }
}
